import React from "react";

import ChevronLeft from "@material-ui/icons/ChevronLeft";

import {
  Show,
  TextField,
  TopToolbar,
  ListButton,
  SimpleShowLayout,
  EditButton,
  useNotify,
  useRefresh,
  useRedirect,
  DateField,
  NumberField,
  ArrayField,
  Datagrid
} from "react-admin";
import { BoxedShowLayout, RaBox } from "ra-compact-ui/dist/details";
import { makeStyles } from "@material-ui/core";

const AbricateTitle = ({ record }) => {
  return <span>Provider {record ? `"${record.code}"` : ""}</span>;
};

const useStyles = makeStyles(theme => ({
  detailsBox: {
      paddingRight: "50px",
      borderRight: "solid thin",
      marginRight: "50px",
  },
}));

const AbricateActions = ({ basePath, data }) => (
  <TopToolbar>
    <ListButton basePath={basePath} label="Back" icon={<ChevronLeft />} />
  </TopToolbar>
);

const AbricateShow = (props) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  const onFailure = (error) => {
    notify(`Abricate ${error.message}`, "error");
    sleep(2500).then(() => {
      redirect("/abricate");
      refresh();
    });
  };

  return (
    <Show {...props}>
      <BoxedShowLayout>
          <RaBox display="flex" >
              <RaBox display="inline-flex" flexDirection="column" flexGrow={1}>
                    <TextField source="id" />
                    <TextField source="file" />
                    <TextField source="sequence" />
                    <NumberField source="start" />
                    <NumberField source="end" />
                    <TextField source="strand" />
                    <TextField source="gene" />
                    <TextField source="coverage" />
                    <TextField source="coverage_map" />
              </RaBox>
              <RaBox display="inline-flex" flexDirection="column" flexGrow={1}>
                    <TextField source="gaps" />
                    <NumberField source="porc_coverage" />
                    <NumberField source="porc_identity" />
                    <TextField source="database" />
                    <TextField source="accesion" />
                    <TextField source="product" />
                    <TextField source="resistance" />
              </RaBox>
          </RaBox>
      </BoxedShowLayout>
    </Show>
      
  );
};

export default AbricateShow;
